import { useEffect, useState } from "react";
import changeLogService from "services/change-log-service";

// MUI & Material Dashboard components
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";

// E4A Components
import MDTypography from "components/MDTypography";
import TimelineItem from "e4acomponents/Timeline/TimelineItem";
import TimelineList from "e4acomponents/Timeline/TimelineList";

function ChangesTimeline({
    docId,
    docType
}) {
    const [timelineData, setTimelineData] = useState([]);
    const [showChangeLog, setShowChangeLog] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // Fetches the partcode's change logs
    useEffect(() => {
        (async () => {
            try {
                setIsLoading(true);
                const response = await changeLogService.getDocumentChanges(docType, docId);
                if (response.data.attributes) {
                    setTimelineData(formatChangeLogs([...response.data.attributes].reverse()));
                    setShowChangeLog(true);
                }
            } catch (error) {
                console.error("Error fetching change logs:", error);
            } finally {
                setIsLoading(false);
            }
        })();
    }, [docId, docType]);

    // Facilitates the assocation of the timeline data with the correct icons
    const associatedIcon = {
        "approved": ["check", "success"],
        "rejected": ["close", "error"],
        "created": ["add", "secondary"],
        "added": ["add", "secondary"],
        "updated": ["update", "info"],
        "edit": ["edit", "info"],
        "edited": ["edit", "info"],
        "added to bom": ["link", "primary"],
        "removed from bom": ["linkoff", "warning"],
        "image change": ["image", "info"],
        "attachments change": ["attach_file", "info"],
        "up revision": ["arrow_upward", "success"],
        "organization changed": ["business", "info"],
        "archived": ["archive", "dark"],
        "restored": ["unarchive", "dark"],
        "disabled": ["block", "dark"],
        "enabled": ["check_circle", "dark"],
        "deleted": ["delete", "error"],
    }

    // Formats the changeLogs into timeline data
    const formatChangeLogs = (changeLogs) => {
        return changeLogs.map((changeLog, index) => {
            const color = associatedIcon[changeLog.type.toLowerCase()][1];
            const icon = associatedIcon[changeLog.type.toLowerCase()][0];
            const title = changeLog.type;
            const dateTime = new Date(changeLog.created_at).toLocaleString();
            const description = formatDescription(changeLog);;
            const lastItem = index === changeLogs.length - 1;
            const revNum = changeLog?.revNum || null;
            if (changeLog.comment) {
                const comment = changeLog.comment;
                return { color, icon, title, dateTime, description, comment, lastItem, revNum };
            } else {
                return { color, icon, title, dateTime, description, lastItem, revNum };
            }
        });
    }

    // Formats the description field for timeline items
    const formatDescription = (changeLog) => {
        return `${changeLog.description} by ${changeLog.user.name}`;
    }

    // Renders the timeline items
    const renderTimelineItems = timelineData.map(
        ({ color, icon, title, dateTime, description, comment, lastItem }) => (

            <TimelineItem
                key={title + color}
                color={color}
                icon={icon}
                title={title}
                dateTime={dateTime}
                description={description}
                comment={comment}
                lastItem={lastItem}
            />
        )
    );

    return (
        <MDBox>
            <MDBox>
                {isLoading ? (
                    <MDBox display="flex" justifyContent="center" alignItems="center" height="200px">
                        <CircularProgress />
                    </MDBox>
                ) : (
                    showChangeLog ? (
                        <TimelineList noCard>{renderTimelineItems}</TimelineList>

                    ) : (
                        <MDTypography variant="h6" textAlign="center" p={2}>
                            No change logs available
                        </MDTypography>
                    ))}
            </MDBox>
        </MDBox >
    )
}
export default ChangesTimeline;